import { render, staticRenderFns } from "./PdfDownloader.vue?vue&type=template&id=360c606c&scoped=true"
import script from "./PdfDownloader.vue?vue&type=script&lang=js"
export * from "./PdfDownloader.vue?vue&type=script&lang=js"
import style0 from "./PdfDownloader.vue?vue&type=style&index=0&id=360c606c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360c606c",
  null
  
)

export default component.exports